export default __webpack_public_path__ + "static/media/tiendasextra.316a4974.png";